import { ChangeEventHandler } from 'react';
import _debounce from 'lodash.debounce';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useLocation, useNavigate } from 'react-router-dom';

function PackageSearch() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const query = params.get('query') || '';

  const debounceFn = _debounce((query: string) => {
    if (query != '') {
      params.set('query', query);
    } else {
      params.delete('query');
    }
    navigate(`${location.pathname}?${params}`);
  }, 1000);

  const handleSearch: ChangeEventHandler<HTMLInputElement> = event => {
    return debounceFn(event.target.value);
  };

  return (
    <div className='mx-auto my-4 flex w-full max-w-sm items-center gap-3 sm:px-0'>
      <span className='hidden sm:inline'>جست و جو:</span>
      <label
        htmlFor='search'
        className='relative mx-auto block max-w-xs flex-1 text-gray-400 focus-within:text-gray-600'
      >
        <MagnifyingGlassIcon
          width={20}
          height={20}
          className='pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 transform'
        />
        <input
          type='seach'
          name='search'
          id='search'
          defaultValue={query}
          onChange={handleSearch}
          className='w-full rounded-xl border border-gray-300 p-1.5 text-center'
        />
      </label>
    </div>
  );
}

export default PackageSearch;
